import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
export const get_customers = createAsyncThunk(
    'chat/get_customers',
    async (sellerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.get(`/chat/seller/get-customers/${sellerId}`, { withCredentials: true } /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)

export const get_customer_message = createAsyncThunk(
    'chat/get_customer_message',
    async (request, { rejectWithValue, fulfillWithValue, getState }) => {
                // const token = getState().auth.token
                // const config = {
                //     headers: {
                //         'Authorization': `Bearer ${token}`
                //     }
                // }
                // console.log(config);
        
        try {
            const customerId = typeof request === 'string' ? request : request.customerId
            const cursor = typeof request === 'string' ? undefined : request.cursor
            const { data } = await api.get(`/chat/seller/get-customer-message/${customerId}`, { withCredentials: true, params: { cursor, limit: 30 } } /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)

export const fetch_chat_announcements = createAsyncThunk(
    'chat/fetch_announcements',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/chat/seller/announcements', { withCredentials: true })
            return fulfillWithValue(data || {})
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Bildiriş mesajları yüklənmədi' })
        }
    }
)

export const mark_chat_announcement_read = createAsyncThunk(
    'chat/mark_announcement_read',
    async (announcementId, { fulfillWithValue }) => {
        await api.patch(`/chat/seller/announcements/${announcementId}/read`, {}, { withCredentials: true })
        return fulfillWithValue(announcementId)
    }
)

export const send_message = createAsyncThunk(
    'chat/send_message',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.post('/chat/seller/send-message-to-customer', info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)


export const get_sellers = createAsyncThunk(
    'chat/get_sellers',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.get('/chat/admin/get-sellers', { withCredentials: true } /*config*/)
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)


export const send_message_seller_admin = createAsyncThunk(
    'chat/send_message_seller_admin',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const role = getState().auth.role || getState().auth.userInfo?.role
            const endpoint = role === 'seller'
                ? '/chat/seller/message-send-admin'
                : '/chat/message-send-seller-admin'
            const { data } = await api.post(endpoint, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)


export const get_admin_message = createAsyncThunk(
    'chat/get_admin_message',
    async (receverId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.get(`/chat/get-admin-messages/${receverId}`, { withCredentials: true } /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)

export const get_seller_message = createAsyncThunk(
    'chat/get_seller_message',
    async (receverId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.get('/chat/get-seller-messages', { withCredentials: true } /*config*/)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Request failed' })
        }
    }
)




export const chatReducer = createSlice({
    name: 'seller',
    initialState: {
        successMessage: '',
        errorMessage: '',
        customers: [],
        messages: [],
        activeCustomer: [],
        activeSellers: [],
        messageNotification: [],
        activeAdmin: "",
        friends: [],
        seller_admin_message: [],
        currentSeller: {},
        currentCustomer: {},
        sellers: [],
        nextCursor: null,
        hasMore: false,
        historyLoading: false,
        historyError: '',
        customersLoading: false,
        customersError: '',
        sendLoading: false,
        chatAnnouncements: [],
        chatAnnouncementUnread: 0,
        chatAnnouncementsLoading: false,
        chatAnnouncementsError: ''
    },
    
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        updateMessage: (state, { payload }) => {
            if (payload?._id && state.messages.some(m => m._id === payload._id)) return
            state.messages = [...state.messages, payload]
        },
        updateCustomer: (state, { payload }) => {
            state.activeCustomer = payload
        },
        updateSellers: (state, { payload }) => {
            state.activeSellers = payload
        },
        updateActiveSellers: (state, { payload }) => {
        state.activeSellers = payload
    },
        updateAdminMessage: (state, { payload }) => {
            if (payload?._id && state.seller_admin_message.some(m => m._id === payload._id)) return
            state.seller_admin_message = [...state.seller_admin_message, payload]
        },
        updateSellerMessage: (state, { payload }) => {
            if (payload?._id && state.seller_admin_message.some(m => m._id === payload._id)) return
            state.seller_admin_message = [...state.seller_admin_message, payload]
        },
        activeStatus_update: (state, { payload }) => {
            state.activeAdmin = payload.status
        }
    },
    extraReducers: (builder) => {
    builder

      // ✅ GET CUSTOMERS
      .addCase(get_customers.pending, (state) => {
        state.customersLoading = true
        state.customersError = ''
      })
      .addCase(get_customers.fulfilled, (state, { payload }) => {
        state.customers = payload.customers
        state.customersLoading = false
      })
      .addCase(get_customers.rejected, (state) => {
        state.customersLoading = false
        state.customersError = 'Söhbətlər yüklənmədi'
      })

    //   ✅ GET CUSTOMER MESSAGE
      .addCase(fetch_chat_announcements.pending, (state) => {
        state.chatAnnouncementsLoading = true
        state.chatAnnouncementsError = ''
      })
      .addCase(fetch_chat_announcements.fulfilled, (state, { payload }) => {
        state.chatAnnouncements = payload.announcements || []
        state.chatAnnouncementUnread = state.chatAnnouncements.filter(item => !item.isRead).length
        state.chatAnnouncementsLoading = false
      })
      .addCase(fetch_chat_announcements.rejected, (state, { payload }) => {
        state.chatAnnouncementsLoading = false
        state.chatAnnouncementsError = payload?.error || 'Bildiriş mesajları yüklənmədi'
      })
      .addCase(mark_chat_announcement_read.fulfilled, (state, { payload }) => {
        state.chatAnnouncements = state.chatAnnouncements.map(item => item._id === payload ? { ...item, isRead: true, readAt: item.readAt || new Date().toISOString() } : item)
        state.chatAnnouncementUnread = state.chatAnnouncements.filter(item => !item.isRead).length
      })
      .addCase(get_customer_message.pending, (state, { meta }) => {
        if (typeof meta.arg === 'object' && meta.arg?.cursor) state.historyLoading = true
        if (!(typeof meta.arg === 'object' && meta.arg?.cursor)) state.historyError = ''
      })
      .addCase(get_customer_message.fulfilled, (state, { payload, meta }) => {
        if (typeof meta.arg === 'object' && meta.arg?.cursor) {
          const existingIds = new Set(state.messages.map(message => String(message._id)))
          state.messages = [...payload.messages.filter(message => !existingIds.has(String(message._id))), ...state.messages]
        } else {
          state.messages = payload.messages
        }
        state.currentCustomer = payload.currentCustomer
        state.nextCursor = payload.nextCursor || null
        state.hasMore = Boolean(payload.hasMore)
        state.historyLoading = false
        state.historyError = ''
      })
      .addCase(get_customer_message.rejected, (state, { meta }) => {
        state.historyLoading = false
        if (!(typeof meta.arg === 'object' && meta.arg?.cursor)) state.historyError = 'Mesajlar yüklənmədi'
      })

      // ✅ SEND MESSAGE CUSTOMER
      .addCase(send_message.pending, (state) => {
        state.sendLoading = true
        state.errorMessage = ''
      })
      .addCase(send_message.fulfilled, (state, { payload }) => {
        let tempFriends = state.customers
        let index = tempFriends.findIndex(
          f => f.fdId === payload.message.receverId
        )

        while (index > 0) {
          let temp = tempFriends[index]
          tempFriends[index] = tempFriends[index - 1]
          tempFriends[index - 1] = temp
          index--
        }

        state.customers = tempFriends
        state.messages.push(payload.message)
        state.successMessage = 'message send success'
        state.sendLoading = false
      })
      .addCase(send_message.rejected, (state, { payload }) => {
        state.sendLoading = false
        state.errorMessage = payload?.error || payload?.message || 'Mesaj göndərilmədi'
      })

    //   // ✅ GET SELLERS
      .addCase(get_sellers.fulfilled, (state, { payload }) => {
        state.sellers = payload.sellers
      })

      // ✅ SEND MESSAGE SELLER → ADMIN
      .addCase(send_message_seller_admin.fulfilled, (state, { payload }) => {
        state.seller_admin_message.push(payload.message)
        state.successMessage = 'message send success'
      })

      // ✅ GET ADMIN MESSAGE
      .addCase(get_admin_message.fulfilled, (state, { payload }) => {
        state.seller_admin_message = payload.messages
        state.currentSeller = payload.currentSeller
      })

    //   // ✅ GET SELLER MESSAGE
      .addCase(get_seller_message.fulfilled, (state, { payload }) => {
        state.seller_admin_message = payload.messages
      })
  }

    

})
export const { messageClear, updateMessage, updateCustomer, updateSellers, updateAdminMessage, updateSellerMessage, activeStatus_update } = chatReducer.actions
export default chatReducer.reducer
